<template>
  <div>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="!loading && errorMessage !== null">
      {{errorMessage}}
    </div>
    <div class="loading" v-if="!loading && errorMessage === null">

      <md-card>
        <md-card-header>
          <div class="md-title">Users</div>
        </md-card-header>

        <md-card-content>
          <md-table>

            <md-table-row>
              <md-table-head md-sort-name="name">Username</md-table-head>
              <md-table-head>Name</md-table-head>
              <md-table-head>Permission</md-table-head>
              <md-table-head>Cities</md-table-head>
              <md-table-head>Enabled</md-table-head>
            </md-table-row>

            <md-table-row v-for="user in users" :key="user.versionedId.id" >
              <md-table-cell>
                <span v-if="!user.edit">{{user.username.username}}</span>
                <span v-if="user.edit">
                  <md-field>
                    <md-input v-focus v-model="user.username.username" @keyup.enter="saveUser(user)" @keyup.esc="cancelEditUser(user)"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(user.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(user.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{user.oldUser.username.username}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!user.edit">{{user.name}}</span>
                <span v-if="user.edit">
                  <md-field>
                    <md-input v-model="user.name" @keyup.enter="saveUser(user)" @keyup.esc="cancelEditUser(user)"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(user.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(user.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{user.oldUser.name}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!user.edit">
                  {{permissions[user.permissionLevel]}}
                </span>
                <md-field v-if="user.edit">
                  <md-select v-model="user.permissionLevel" :disabled="!user.edit">
                    <md-option value="CITY_VIEW">City View</md-option>
                    <md-option value="CITY_ADMIN">City Admin</md-option>
                    <md-option value="ADMINISTRATOR">Administrator</md-option>
                    <md-option value="SUPER_USER">Super User</md-option>
                  </md-select>
                  <span class="md-helper-text" v-if="user.edit">{{permissions[user.oldUser.permissionLevel]}}</span>
                </md-field>
              </md-table-cell>

              <md-table-cell v-if="!user.edit">
                {{user.cityIds.length}}
              </md-table-cell>
              <md-table-cell style="text-align: left;" v-if="user.edit">
                <span :key="city.versionedId.id" v-for="city in cities" >
                  <md-checkbox v-model="user.cityIds" :value="city.versionedId.id">{{city.name}}</md-checkbox>
                  <br/>
                </span>
              </md-table-cell>

              <md-table-cell>
                <md-checkbox v-model="user.enabled" :disabled="!user.edit" />
              </md-table-cell>

              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" @click="editUser(user)" v-if="!user.edit"  v-bind:disabled="user.saving">
                  <md-icon class="md-morph-final">edit</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="saveUser(user)" v-if="user.edit">
                  <md-icon class="md-morph-final">save</md-icon>
                  <md-tooltip md-delay="2000">Save</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="cancelEditUser(user)" v-if="user.edit">
                  <md-icon class="md-morph-final">cancel</md-icon>
                  <md-tooltip md-delay="2000">Cancel</md-tooltip>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary editButton" @click="showResetPasswordDialog(user)" v-if="!user.edit">
                  <md-icon class="md-morph-final">settings_backup_restore</md-icon>
                  <md-tooltip md-delay="2000">Reset Password</md-tooltip>
                </md-button>
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!user.edit && isSoftLocked(user.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(user.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-fab" @click="showNewUserDialog">
            <md-icon>person_add</md-icon>
          </md-button>
        </md-card-actions>
      </md-card>

    </div>

    <md-dialog :md-active.sync="resetUserPasswordPromptActive" style="z-index: 5">
      <md-dialog-title>New password for {{userToReset.name}}</md-dialog-title>
      <div class="dialogContent">
        <md-field>
          <label>Password</label>
          <md-input v-focus ref="resetPasswordFirstField" v-model="newUserPassword" type="password" @keyup.enter="resetPassword(userToReset.versionedId, newUserPassword)" ></md-input>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="resetUserPasswordPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="resetPassword(userToReset.versionedId, newUserPassword)" v-bind:disabled="!(newUserPassword.length > 0)">Save</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="createUserPromptActive" style="z-index: 5">
      <md-dialog-title>Create a new User</md-dialog-title>

      <div class="dialogContent">
        <md-field >
          <label>Name</label>
          <md-input v-focus ref="newObjectFirstField" v-model="newUserName"></md-input>
        </md-field>

        <md-field>
          <label>Username</label>
          <md-input v-model="newUserUsername"></md-input>
        </md-field>

        <md-field>
          <label>Password</label>
          <md-input v-model="newUserPassword" type="password"></md-input>
        </md-field>

        <md-field>
          <label>Permission</label>
          <md-select v-model="newUserPermissionLevel">
            <md-option value="CITY_VIEW">City View</md-option>
            <md-option value="CITY_ADMIN">City Admin</md-option>
            <md-option value="ADMINISTRATOR">Administrator</md-option>
            <md-option value="SUPER_USER">Super User</md-option>
          </md-select>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="createUserPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="createUser" v-bind:disabled="!dialogCreateActive">Create</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-snackbar md-position="center" :md-duration="8000" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
  var nameComparitor = function (a, b) {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  };

  export default {
    name: 'admin-users',
    data() {
      return {
        loading: true,
        errorMessage: null,
        users: [],
        cities: [],
        createUserPromptActive: false,
        newUserUsername: '',
        newUserName: '',
        newUserPassword: '',
        newUserPermissionLevel: '',
        userSubscriptionId: null,
        citySubscriptionId: null,
        showSnackbar: false,
        snackbarMessage: '',
        resetUserPasswordPromptActive: false,
        userToReset: {},
        mutableFields: ['username', 'name', 'permissionLevel', 'cityIds', 'enabled'],
        permissions: {
          SUPER_USER: "Super User",
          ADMINISTRATOR: "Administrator",
          CITY_ADMIN: "City Admin",
          CITY_VIEW: "City View"
        }
      }
    },
    computed: {
      dialogCreateActive() {
        return this.newUserUsername.length >= 1 && this.newUserName.length >= 1;
      }
    },
    created() {
      this.citySubscriptionId = this.$store.api.subscribe("CITY", null, this.cityChangeHandler);
      this.getCities();
      this.userSubscriptionId = this.$store.api.subscribe("USER", null, this.userChangeHandler);
      this.getUsers();
    },
    beforeDestroy() {
      if (this.userSubscriptionId) {
        this.$store.api.unsubscribe(this.userSubscriptionId);
      }
      this.userSubscriptionId = null;
      if (this.citySubscriptionId) {
        this.$store.api.unsubscribe(this.citySubscriptionId);
      }
      this.citySubscriptionId = null;
    },
    methods: {
      getUsers() {
        this.loading = true;
        this.errorMessage = null;
        this.$store.api.rpcRequest('getAllUsers', {}, rawUsers => {
          var users = [];
          rawUsers.forEach(user => {
              users.push(this.userTransformer(user));
            }
          );
          users.sort(nameComparitor);
          this.users = users;
          this.loading = false;
        }, errorMessage => {
          this.loading = false;
          this.errorMessage = errorMessage;
        });
      },
      getCities() {
        this.$store.api.rpcRequest('getAllCities', {}, rawCities => {
          rawCities.sort(nameComparitor);
          this.cities = rawCities;
        }, errorMessage => {
          this.errorMessage = errorMessage;
        });
      },
      showNewUserDialog() {
        this.newUserName = '';
        this.newUserUsername = '';
        this.newUserPermissionLevel = '';
        this.newUserPassword = '';
        this.createUserPromptActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.newObjectFirstField.$el.focus()), 300);
      },
      createUser() {
        this.createUserPromptActive = false;
        this.$store.api.rpcRequest('createUser', {
          name: this.newUserName,
          username: {
            username: this.newUserUsername
          },
          permissionLevel: this.newUserPermissionLevel,
          password: this.newUserPassword
        }, newUser => {
        }, errorMessage => {
        });
      },
      userTransformer(user) {
        user.edit = false;
        user.saving = false;
        var cityIds = [];
        user.cityIds.forEach(id => {
          cityIds.push(id.id);
        });
        user.cityIds = cityIds;
        return user;
      },
      editUser(user) {
        if (!user.edit) {
          var oldUser = Object.assign({}, user);
          user.oldUser = oldUser;
          user.edit = true;
          this.$store.api.softLock(this.$route.fullPath, user.versionedId.id);
        }
      },
      cancelEditUser(user) {
        if (user.edit) {
          this.mutableFields.forEach(fieldName => {
            user[fieldName] = user.oldUser[fieldName];
          });
          user.edit = false;
          this.$store.api.softUnlock(this.$route.fullPath, user.versionedId.id);
        }
      },
      saveUser(user) {
        if (user.edit) {
          this.$store.api.softUnlock(this.$route.fullPath, user.versionedId.id);
          user.edit = false;
          user.saving = true;
          var userParameters = {versionedId: user.versionedId};
          this.mutableFields.forEach(fieldName => {
            userParameters[fieldName] = user[fieldName];
          });

          this.$store.api.rpcRequest('saveUser', userParameters, savedUser => {
            user.saving = false;
          }, errorMessage => {
            user.edit = true;
            user.saving = false;
            this.$store.api.softLock(this.$route.fullPath, user.versionedId.id);
          });
        }
      },
      userChangeHandler(newUser) {
        var found = false;
        newUser = this.userTransformer(newUser);
        this.users.forEach(user => {
          if (user.versionedId.id === newUser.versionedId.id) {
            found = true;
            if (user.edit) {
              this.showSnackbar = true;
              this.snackbarMessage = "A user you were editing was modified!";

              this.mutableFields.forEach(fieldName => {
                if (user[fieldName] === user.oldUser[fieldName]) {
                  user[fieldName] = newUser[fieldName];
                } else {
                  // console.dir("did not merge " + fieldName)
                }
              });
              Object.assign(user.versionedId, newUser.versionedId);
              Object.assign(user.oldCity, newUser);
            } else {
              Object.assign(user, newUser);
            }
          }
        });
        if (!found) {
          this.users.push(newUser);
        }

        this.users.sort(nameComparitor);
      },
      cityChangeHandler(newCity) {
        var found = false;
        this.cities.forEach(city => {
          if (city.versionedId.id === newCity.versionedId.id) {
            found = true;
            Object.assign(city, this.cityTransformer(newCity));
          }
        });
        if (!found) {
          this.cities.push(this.cityTransformer(newCity));
        }

        this.cities.sort(nameComparitor);
      },
      isSoftLocked(lockId) {
        return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
      },
      getLockedByString(lockId) {
        if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
          return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
        } else {
          return "";
        }
      },
      showResetPasswordDialog(user) {
        this.newUserPassword = '';
        this.userToReset = user;
        this.resetUserPasswordPromptActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.resetPasswordFirstField.$el.focus()), 300);
      },
      resetPassword(versionedId, password) {
        this.resetUserPasswordPromptActive = false;
        this.$store.api.rpcRequest('resetPassword', {
          versionedId: versionedId,
          password: password
        }, newUser => {
        }, errorMessage => {
          this.resetUserPasswordPromptActive = true;
        });
      }
    }
  }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}

</style>



// WEBPACK FOOTER //
// src/components/admin/Users.vue